class NoticeComponent {
  constructor($timeout, $state) {
    'ngInject';

    this.$timeout = $timeout;
    this.$state = $state;
  }

  $onInit() {}

  closeNotice() {
    window.dataLayer.push({
      event: 'noticeClosed'
    })
    this.close();
  }

  adminPage() {
    this.$state.go('admin');
  }
}

export default {
  template: require('./notice.template.html'),
  controller: NoticeComponent,
  controllerAs: 'vm',
  bindings: {
    noResults: '<',
    close: '&'
  }
};